<template>
  <div class="titleList">
    <p class="listSize">
      {{ $t('iDalgoListEdit.title.listSize', { listSize: listSize }) }}</p>
    <h2>{{ template.name }}</h2>
    <p class="counterResume" v-html="listCounterHtml"></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'iDalgo-List-Title',
  props: {},
  computed: {
    ...mapGetters({
      size: 'templates/size',
      sections: 'templates/sections',
      template: 'templates/template'
    }),
    listSize () {
      return this.size
    },
    listCounterHtml () {
      return this.$t('iDalgoListEdit.title.description', {
        listSize: `<span class="red"> ${this.size} </span>`,
        totalPlayers: `<span class="red"> ${this.totalPlayers} </span>`
      })
    },
    totalSectionsSize () {
      if (this.sections.length !== 0) {
        return this.sections.map(section => {
          return section.size
        }).reduce((a, b) => a + b)
      }
    },
    totalPlayers () {
      if (this.sections.length !== 0) {
        return this.sections.map(section => {
          return section._players.length
        }).reduce((a, b) => a + b)
      }
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss">
  .titleList {
    margin: 0px 0px 20px 0px;
    border-left: 5px solid $color2;
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    color: $color1;
    .listSize {
      opacity: 0.21;
      color: $color1;
      font-size: 16px;
      font-family: 'robotoblack';
      margin: 5px 0px 0px 0px;
      text-transform: uppercase;
    }
    h2 {
      margin: 5px 0px;
      font-size: 32px;
      font-family: 'robotomedium';
    }
    .counterResume {
      margin: 0px 0px 5px 0px;
      font-size: 20px;
      .red {
        color: $color2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-List-Title.vue